import { useQuery } from "@tanstack/react-query";
import camelcaseKeys from "camelcase-keys";
import { AxiosError, AxiosResponse } from "axios";

import { AXIOS } from "hooks/axios";
import { useAuth } from "components/auth/AuthProvider";
import { Snapshot } from "./base";
import { MetaSchema, PaginationSchema } from "hooks/pagination";

type SnapshotWithError = Snapshot & { error?: any };

export type HistorySchema = {
  id: string;
  host: string;
  updatedAt: string;
  serialNumber: string;
  data: {
    data: SnapshotWithError;
    error: string | null;
  };
};

type usePavmHistorySchema = PaginationSchema & {
  host: string;
  serialNumber: string;
  updatedAt: {
    gte: string;
    lt: string;
  };
};

export const usePavmHistory = (body: usePavmHistorySchema) => {
  const { user } = useAuth();
  const uri = user.project.uri;

  return useQuery<
    AxiosResponse<any, any>,
    AxiosError<{ message: string }>,
    { data: HistorySchema[]; meta: MetaSchema }
  >(
    [`PAVM HISTORY URI: ${uri} ${JSON.stringify(body)}`],
    () => AXIOS.post(`${uri}/history`, body),
    {
      select: (data) => camelcaseKeys(data.data, { deep: true }),
      staleTime: 1000 * 120,
    }
  );
};

export const usePavmHistoryHsm = ({
  uri,
  host,
  serialNumber,
  dateFilter,
}: {
  uri: string;
  host: string;
  serialNumber: string;
  dateFilter: {
    gte: string;
    lte: string;
  };
}) => {
  return useQuery(
    [
      `PAVM HISTORY HSM, URI: ${uri} HOST: ${host} SERIAL NO: ${serialNumber} GTE: ${dateFilter.gte} LTE: ${dateFilter.lte}`,
    ],
    () =>
      AXIOS.post(`${uri}/${host}/history/hsm`, { serialNumber, dateFilter }),
    {
      enabled: !!uri && !!host,
      select: (data) => camelcaseKeys(data.data.history, { deep: true }),
    }
  );
};
